<script setup lang="ts">
import { defineAsyncComponent, computed, inject } from '#imports'
import type { Ref } from '#imports'

const YscLabel = defineAsyncComponent(() => import('./YscLabel.vue'))

interface Props {
  for?: string
  disabled?: boolean
  required?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  required: false,
})

// FIXME: use interface from api js
interface FieldError {
  label: {
    text: string
    needTranslation: boolean
    translationParams?: {
      [key: string]: string | number
    }
  }
  description?: {
    text: string
    needTranslation: boolean
    translationParams?: {
      [key: string]: string | number
    }
  }
}
const formErrors = inject<Ref<FieldError[]> | null>('ysc-form-errors', null)
const error = computed(() => {
  if (!formErrors?.value || !props.for) {
    return
  }
  const error = formErrors.value.find(error => error.label.text === props.for)
  return error?.description
})
</script>

<template>
  <div>
    <YscLabel
      v-if="$slots.default"
      v-bind="$attrs"
      :disabled="disabled"
      :required="required"
      class="inline-block"
      :class="{ 'mb-2': !$slots.description }"
    >
      <slot name="default" />
    </YscLabel>

    <p
      v-if="$slots.description"
      class="mb-2 max-w-prose text-sm text-gray-500"
    >
      <slot name="description" />
    </p>

    <slot name="inputBlock" />

    <p
      v-if="$slots.error || error?.text"
      class="mt-2 max-w-prose text-sm font-semibold text-red-500"
    >
      <slot name="error" />
      <template v-if="error?.text">
        {{ error.text }}
      </template>
    </p>
  </div>
</template>
